import { DoorsWithLocationsStateComplete, DrawerStates } from 'state/types';
import { filterBySearchTerm } from 'utils/FilterBySearchTerm/FilterBySearchTerm.util';

export const getFilterData = (
  filterStr: string,
  doorsWithLocations: DoorsWithLocationsStateComplete
): DoorsWithLocationsStateComplete => filterBySearchTerm(doorsWithLocations, filterStr, (door) => [door.name]);

export const handleSelectDoor = (
  doorId: string,
  selectedDoors: string[],
  setSelectedDoors: React.Dispatch<React.SetStateAction<string[]>>
) => {
  if (selectedDoors.some((door) => door === doorId)) setSelectedDoors(selectedDoors.filter((door) => door !== doorId));
  else setSelectedDoors([...selectedDoors, doorId]);
};

export const handleCancelButton = (showDrawer: (drawer: DrawerStates) => void, hideModal: () => void) => {
  showDrawer({
    type: 'manageLockGroups'
  });
  hideModal();
};
